<template>
    <v-container fluid class="pa-0">
        <!--get info-->
        <v-container class="my-4">
            <v-form v-model="valid" ref="form" validation>
                <v-row>
                    <v-col cols="12" sm="4" md="2">
                        <v-select dense color="secondary" item-color="secondary" return-object v-model="set" :items="sets"
                            item-text="item" item-value="value" 
                            label="category of game" 
                            :rules="[rules.required]">
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="2">
                        <v-select dense color="secondary" 
                            item-color="secondary"
                            return-object
                            v-model.number="round" 
                            :items="rounds" 
                            label="round" 
                            :rules="[rules.number]">
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="3" md="2" class="mt-4">
                        <v-btn color="secondary" small dark class="text-lowercase" :disabled="!valid || Boolean(error)"
                            @click="load">load
                        </v-btn>
                    </v-col>
                    <v-col cols="12" class="mt-4" sm="3" md="2" v-if="teamsRout && valid">
                        <add-team :set="set"></add-team>
                    </v-col>
                    <v-col cols="12" class="mt-4" sm="3" md="2" v-else-if="productsRout && valid">
                        <add-product :set="set" :round="round" />
                    </v-col>
                    <v-col cols="12" class="mt-4" sm="3" md="2" v-else-if="gamesRout && valid">
                        <add-game :set="set" :round="round" />
                    </v-col>
                    <v-col cols="12" class="mt-4" sm="3" md="2" v-else-if="channelsRout && valid">
                        <add-channel :set="set" :round="round" />
                    </v-col>
                    <v-col cols="12" class="mt-4" sm="3" md="2" v-else-if="promotionRout && valid">
                        <add-spot :set="set" :round="round" />
                    </v-col>
                    <v-col cols="12" class="mt-4" sm="3" md="2" v-else-if="resourcesRout && valid">
                        <add-resource :set="set" :round="round" />
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
        <v-divider></v-divider>
        <!--teams-->
        <v-tabs v-model="tab" height="35" background-color="primary" fixed-tabs hide-slider dark>
            <v-tab :to="link(item)" ripple class="text-capitalize" exact-active-class v-for="item in itemsTab" :key="item">
                {{ item }}
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item value="/admin/teams/games">
                <games></games>
                </v-tab-item>
            <v-tab-item value="/admin/teams/teams">
                <teams></teams>
            </v-tab-item>
            <v-tab-item value="/admin/teams/products">
                <products />
            </v-tab-item>
            <v-tab-item value="/admin/teams/channels">
                <channels />
            </v-tab-item>
            <v-tab-item value="/admin/teams/promotion">
                <promotion />
            </v-tab-item>
            <v-tab-item value="/admin/teams/resources">
                <resources />
            </v-tab-item>
            <!-- independent chains
            <v-tab-item value="/admin/market/chains">
                <chains></chains>
            </v-tab-item> -->
        </v-tabs-items>
    </v-container>
</template>
<script>
import Teams from './teams/Info.vue'
import Products from './teams/Products.vue'
import Channels from './teams/Channels.vue'
import Promotion from './teams/Promotion.vue'
import Resources from './teams/Resources.vue'
import Games from './teams/Games.vue'

import AddTeam from '../../components/admin/teams/addTeam.vue'
import AddProduct from '../../components/admin/products/addProduct.vue'
import AddGame from '../../components/admin/games/addGame.vue'

import AddChannel from '../../components/admin/channels/addChannel.vue'
import AddSpot from '../../components/admin/spots/addSpot.vue'
import AddResource from '../../components/admin/resources/addResource.vue'

export default {
    data() {
        return {
            itemsTab: ['Games', 'Teams', 'Products', 'Channels', 'Promotion', 'Resources'],
            tab: 0,
            valid: false,
            error: '',
            set: { item: 'standart', value: 2 },
            round: 0,
            rules: {
                required: value => !!value || 'required field',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
            }
        }
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
        games() {
            return this.$store.getters.games;
        },
        gamesRout() {
            return /\/teams\/games/.test(this.$route.path)
        },
        teamsRout() {
            return /\/teams\/teams/.test(this.$route.path)
        },
        productsRout() {
            return /\/teams\/products/.test(this.$route.path)
        },
        channelsRout() {
            return /\/teams\/channels/.test(this.$route.path)
        },
        promotionRout() {
            return /\/teams\/promotion/.test(this.$route.path)
        },
        resourcesRout() {
            return /\/teams\/resources/.test(this.$route.path)
        },
        sets() {
            const fixed_arr = [
                { item: 'simple', value: 1 },
                { item: 'standart', value: 2 },
                { item: 'advanced', value: 3 }
            ]

            const custom_arr = this.games.filter(game => game.id > 3)
            if (custom_arr.length > 0) {
                custom_arr.map(item => {
                    fixed_arr.push({
                        item: item.id,
                        value: item.id
                    })
                })
            }

            return fixed_arr;
        },
        rounds() {
            const fixed_arr = [0];
            if (this.set.value > 3) {
                const currentGame = this.games.find(game => game.id == this.set.value);
                if (currentGame && currentGame.round > 0) {
                    for (let i = 1; i <= currentGame.round; i++) {
                        fixed_arr.push(i)
                    }
                }
            }
            //console.log(fixed_arr);
            return fixed_arr;
        }
    },
    methods: {
        link(name) {
            return `/admin/teams/${name.toLowerCase()}`
        },
        async load() {
            let gameId = this.set.value;
            let round = this.round;
            let limit = 6;

            const currentGame = this.games?.find(game => game.id == gameId);
            if (currentGame) {
                limit = currentGame.num_teams;
            }
            const obj = {
                gameId: gameId,
                round: round,
            }
            try {
                if (this.teamsRout) {
                    await this.$store.dispatch('fetchTeams', { gameId, limit });
                }
                else if (this.productsRout) {
                    await this.$store.dispatch('fetchProducts', obj);
                }
                else if (this.gamesRout) {
                    await this.$store.dispatch('fetchUserGames');
                }
                else if (this.channelsRout) {
                    await this.$store.dispatch('fetchChannels', obj);
                } 
                else if (this.promotionRout) { 
                    await this.$store.dispatch('fetchSpots', obj); 
                }
                else if (this.resourcesRout) {
                    await this.$store.dispatch('fetchResources', obj);
                    await this.$store.dispatch('fetchIntermediary', obj);
                    await this.$store.dispatch('fetchFinances', obj);
                }
            }
            catch (err) {
                console.log(err)
            }
        }
    },
    components: {
        Teams, Products, Channels, Promotion, Resources, Games,
        AddTeam, AddProduct, AddGame, AddChannel, AddSpot, AddResource,
    },
    async mounted() {
        if (!this.games?.length) {
            try {
                await this.$store.dispatch('fetchAllGames');
            }
            catch (error) {
                console.log(error.message)
            }
        }
    }

}
</script>